<template>
    <div :class="[
        'aprh__page position--relative',
        itsNotAnErrorPage ? 'aprh__page--default' : 'aprh__page--error'
    ]">
        <block-header
            v-if="itsNotAnErrorPage"
            :canSearch="canSearch"
        />
        <transition
            name="fade"
            mode="out-in"
        >
            <div
                v-if="loading"
                class="aprh__page__loading position--absolute display--flex"
            >
                <loading-logo/>
            </div>
            <router-view
                v-else
                v-bind="{
                    ...data,
                    hasLoading: loading,
                }"
                :key="$route.name"
                :input="() => import( /* webpackChunkName: 'BaseField' */ '@/components/bundles/fields/BaseField' )"
            />
        </transition>
    </div>
</template>

<script>
// packages
import {
    computed,
    watch
} from '@vue/composition-api';

// store
// eslint-disable-next-line
import { mapState } from '@/hooks/use-store';

// hooks
// eslint-disable-next-line
import useModels from '@/hooks/use-models';

export default {
    components: {
        BlockHeader: () => import( /* webpackChunkName: 'Header' */ '@/components/bundles/layout/header/Header' ),
        LoadingLogo: () => import( /* webpackChunkName: 'LoadingLogo' */ '@/components/bundles/loadings/Logo' )
    },
    setup ( _, { root }) {
        const {
            loading,
            error,
            data,
            fetch
        } = useModels();

        // store - response
        const update = mapState({ module: 'storePayload', key: 'update' });

        watch( () => update.value,
            newUpdate => {
                if ( newUpdate )
                    fetch({ updateModel: true });
            });

        // show search
        const canSearch = computed( () => [ 'clients' ].includes( root.$route.name ) );

        const itsNotAnErrorPage = computed( () => ![ 'notFound' ].includes( root.$route.name ) );

        return {
            loading,
            error,
            data,
            fetch,
            itsNotAnErrorPage,
            canSearch
        };
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Styles
    // =============================================================================
    .aprh {
        &__page {
            min-height: 100vh;
            padding-top: $header-height;
            &--default {
                padding-bottom: 87px;
            }
            &--error {
                background: rgba( $color-grey, .4 );
            }
            &__loading {
                @include transform-position( 96px, false, false, -false );
                align-items: center;
                justify-content: center;
                @include dimensions( 100%, calc( 100% - 96px ) );
            }
        }
    }
</style>